<template>
	<aside class="settings-sidebar scrollbar bg-shade-2">
		<header class="flex items-center">
			<CIconButton
				icon="chevron-left"
				:intense="false"
				class="back-button mx-2"
				aria-label="Back"
				@click="$emit('back')"
			/>
			<div>
				<h1 class="sz-1 text-subtle m-0 font-inherit font-medium">{{ pageHeading }}</h1>
				<h2 class="sz-3 m-0">{{ pageSubHeading }}</h2>
			</div>
		</header>
		<nav class="pb-3">
			<ul>
				<li
					v-for="item in navItems"
					:key="item.name"
				>
					<component
						:is="item.type === 'header' ? 'a' : 'router-link'"
						:to="item.type === 'header' ? null : { name: item.name }"
						:href="item.type === 'header' ? item.name : null"
						class="text-primary py-2 pr-4 flex items-center cursor-pointer"
						:class="{
							'active-link': item === activeLink
						}"
						replace
					>
						{{ item.displayName }}
					</component>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import type { NavigationItem } from 'src/layouts/AppSettingsLayout.vue';
	import CIconButton from 'src/components/interaction/IconButton.vue';

	export default defineComponent({
		name: 'SettingsSidebar',
		components: {
			CIconButton
		},
		props: {
			pageHeading: { type: String, required: true },
			pageSubHeading: { type: String, required: true },
			navItems: { type: Array<NavigationItem>, required: true }
		},
		computed: {
			activeLink() {
				const activeRoute = this.navItems.find((item: NavigationItem) => {
					if (item.type === 'header')
						return this.$route.hash === item.name;
					else
						return this.$route.name === item.name;
				});

				if (!activeRoute && this.$route.name === 'account-settings')
					return this.navItems[0];
				else
					return activeRoute;
			}
		}
	});
</script>

<style lang="scss">
.settings-sidebar {
	position: static;
	bottom: 0;
	left: 0;
	top: 0;
	width: 220px;

	@include b-up($b7) {
		width: 280px;
	}

	header {
		padding: $space__4 $space__4 12px 0;
		padding-left: env(safe-area-inset-left, 0px);
	}

	nav {

		a {
			min-height: var(--menu-item-height);
			padding-left: calc($size__icon + $space__3 + $space__4 + env(safe-area-inset-left, 0px));
			line-height: 21px;

			@include hover;

			&.active-link {
				@include selected-menu-item;
			}
		}

		:root & a {
			color: var(--text-primary);
			text-decoration: none;
		}
	}
}
</style>